import { padNumber } from '@witmetrics/utils/numbers';
import { theme } from '@/utils/theme';

export const classes = {
  timeField: 'w-24 mx-4',
  timeIcon: 'text-grey-7 text-base dark:text-mauve-2',
};

export const styles = {
  timeField: {
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette['orange-2'].main,
    },
    '& .MuiInputBase-input': {
      paddingBottom: 0,
    },
    '& .MuiInputAdornment-positionStart': {
      marginLeft: '4px',
      marginRight: '4px',
    },
    '& input[type="time"]::-webkit-calendar-picker-indicator': {
      display: 'none !important',
    },
  },
};

export function formatTimeString(date: Date | null | undefined): string {
  if (!date) return '';
  return `${padNumber(date.getHours())}:${padNumber(date.getMinutes())}`;
}

export function parseTimeString(
  value: string
): { hours: number; minutes: number } | null {
  const [hoursStr, minutesStr] = value.split(':');
  const hours = parseInt(hoursStr);
  const minutes = parseInt(minutesStr);
  if (isNaN(hours) || isNaN(minutes)) return null;
  return { hours, minutes };
}
